<template>
  <v-card>
    <v-card-text>
      <form data-vv-scope="entForm">
        <v-container fluid grid-list-sm>
          <v-layout row wrap>
            <v-flex xs12 md3 lg3>
              <v-subheader class="queryLabel">MAIN ENTRANCE</v-subheader>
            </v-flex>
            <v-flex xs12 md3 lg3 v-if="riskSurveyMode === 'Query'">
              <v-subheader class="queryLabel">{{ labels.mainEntDrMat }}</v-subheader>
              <div class="queryValue" v-for="item in filterMainEntDrMatList" :key="item.label">{{ item.label }}</div>
            </v-flex>
            <v-flex xs12 md3 lg3 v-else>
              <v-autocomplete
                :items="materialList"
                v-model="entForm.mainEntDrMat"
                :label="labels.mainEntDrMat"
                item-text="label"
                item-value="value"
                data-vv-name="entForm.mainEntDrMat"
                :data-vv-as="labels.mainEntDrMat"
                :error-messages="errors.collect('entForm.mainEntDrMat')"
              ></v-autocomplete>
            </v-flex>
            <v-flex xs12 md3 lg3 v-if="riskSurveyMode === 'Query'">
              <v-subheader class="queryLabel">{{ labels.mainEntProt }}</v-subheader>
              <div class="queryValue" v-for="item in filterMainEntProtList" :key="item.label">{{ item.label }}</div>
            </v-flex>
            <v-flex xs12 md3 lg3 v-else>
              <v-autocomplete
                :items="entProtectionList"
                v-model="entForm.mainEntProt"
                :label="labels.mainEntProt"
                item-text="label"
                item-value="value"
                data-vv-name="entForm.mainEntProt"
                :data-vv-as="labels.mainEntProt"
                :error-messages="errors.collect('entForm.mainEntProt')"
              ></v-autocomplete>
            </v-flex>
            <v-flex xs12 md3 lg3 v-if="riskSurveyMode === 'Query'">
              <v-subheader class="queryLabel">{{ labels.mainEntLock }}</v-subheader>
              <div class="queryValue" v-for="item in filterMainEntLockList" :key="item.label">{{ item.label }}</div>
            </v-flex>
            <v-flex xs12 md3 lg3 v-else>
              <v-autocomplete
                :items="entLockTypeList"
                v-model="entForm.mainEntLock"
                :label="labels.mainEntLock"
                item-text="label"
                item-value="value"
                data-vv-name="entForm.mainEntLock"
                :data-vv-as="labels.mainEntLock"
                :error-messages="errors.collect('entForm.mainEntLock')"
              ></v-autocomplete>
            </v-flex>
            <v-flex xs12 md3 lg3>
              <v-subheader class="queryLabel">OTHER ENTRANCE</v-subheader>
            </v-flex>
            <v-flex xs12 md3 lg3 v-if="riskSurveyMode === 'Query'">
              <v-subheader class="queryLabel">{{ labels.othEntDrMat }}</v-subheader>
              <div class="queryValue" v-for="item in filterOthEntDrList" :key="item.label">{{ item.label }}</div>
            </v-flex>
            <v-flex xs12 md3 lg3 v-else>
              <v-autocomplete
                :items="materialList"
                v-model="entForm.othEntDrMat"
                :label="labels.othEntDrMat"
                item-text="label"
                item-value="value"
                data-vv-name="entForm.othEntDrMat"
                :data-vv-as="labels.othEntDrMat"
                :error-messages="errors.collect('entForm.othEntDrMat')"
              ></v-autocomplete>
            </v-flex>
            <v-flex xs12 md3 lg3 v-if="riskSurveyMode === 'Query'">
              <v-subheader class="queryLabel">{{ labels.othEntProt }}</v-subheader>
              <div class="queryValue" v-for="item in filterOthEntProtList" :key="item.label">{{ item.label }}</div>
            </v-flex>
            <v-flex xs12 md3 lg3 v-else>
              <v-autocomplete
                :items="entProtectionList"
                v-model="entForm.othEntProt"
                :label="labels.othEntProt"
                item-text="label"
                item-value="value"
                data-vv-name="entForm.othEntProt"
                :data-vv-as="labels.othEntProt"
                :error-messages="errors.collect('entForm.othEntProt')"
              ></v-autocomplete>
            </v-flex>
            <v-flex xs12 md3 lg3 v-if="riskSurveyMode === 'Query'">
              <v-subheader class="queryLabel">{{ labels.othEntLock }}</v-subheader>
              <div class="queryValue" v-for="item in filterOthEntLockList" :key="item.label">{{ item.label }}</div>
            </v-flex>
            <v-flex xs12 md3 lg3 v-else>
              <v-autocomplete
                :items="entLockTypeList"
                v-model="entForm.othEntLock"
                :label="labels.othEntLock"
                item-text="label"
                item-value="value"
                data-vv-name="entForm.othEntLock"
                :data-vv-as="labels.othEntLock"
                :error-messages="errors.collect('entForm.othEntLock')"
              ></v-autocomplete>
            </v-flex>
            <v-flex xs12 md3 lg3>
              <v-subheader class="queryLabel">WINDOWS / OTHERS</v-subheader>
            </v-flex>
            <v-flex xs12 md3 lg3 v-if="riskSurveyMode === 'Query'">
              <v-subheader class="queryLabel">{{ labels.windMat }}</v-subheader>
              <div class="queryValue" v-for="item in filterWindMatList" :key="item.label">{{ item.label }}</div>
            </v-flex>
            <v-flex xs12 md3 lg3 v-else>
              <v-autocomplete
                :items="materialList"
                v-model="entForm.windMat"
                :label="labels.windMat"
                item-text="label"
                item-value="value"
                data-vv-name="entForm.windMat"
                :data-vv-as="labels.windMat"
                :error-messages="errors.collect('entForm.windMat')"
              ></v-autocomplete>
            </v-flex>
            <v-flex xs12 md3 lg3 v-if="riskSurveyMode === 'Query'">
              <v-subheader class="queryLabel">{{ labels.windProt }}</v-subheader>
              <div class="queryValue" v-for="item in filterWindProtList" :key="item.label">{{ item.label }}</div>
            </v-flex>
            <v-flex xs12 md3 lg3 v-else>
              <v-autocomplete
                :items="entProtectionList"
                v-model="entForm.windProt"
                :label="labels.windProt"
                item-text="label"
                item-value="value"
                data-vv-name="entForm.windProt"
                :data-vv-as="labels.windProt"
                :error-messages="errors.collect('entForm.windProt')"
              ></v-autocomplete>
            </v-flex>
            <v-flex xs12 md3 lg3 v-if="riskSurveyMode === 'Query'">
              <v-subheader class="queryLabel">{{ labels.windLock }}</v-subheader>
              <div class="queryValue" v-for="item in filterWindLockList" :key="item.label">{{ item.label }}</div>
            </v-flex>
            <v-flex xs12 md3 lg3 v-else>
              <v-autocomplete
                :items="entLockTypeList"
                v-model="entForm.windLock"
                :label="labels.windLock"
                item-text="label"
                item-value="value"
                data-vv-name="entForm.windLock"
                :data-vv-as="labels.windLock"
                :error-messages="errors.collect('entForm.windLock')"
              ></v-autocomplete>
            </v-flex>
            <v-flex xs12 v-if="riskSurveyMode === 'Query'">
              <v-subheader class="queryLabel">{{ labels.entRemarks }}</v-subheader>
              <div class="queryValue">{{ entForm.entRemarks }}</div>
            </v-flex>
            <v-flex xs12 v-else>
              <v-textarea
                v-model="entForm.entRemarks"
                :label="labels.entRemarks"
                :error-messages="errors.collect('entForm.entRemarks')"
                v-validate="'max:1000|entry'"
                data-vv-name="entForm.entRemarks"
                :data-vv-as="labels.entRemarks"
                :counter="1000"
                :rows="8"
              ></v-textarea>
            </v-flex>
          </v-layout>
        </v-container>
      </form>
    </v-card-text>
  </v-card>
</template>

<script>
import MessageMixin from '@/mixins/message'
import { formatDisplayDate } from '@/utils/date'
import { materialList, entProtectionList, entLockTypeList } from './index'

export default {
  data() {
    return {
      labels: {
        mainEntDrMat: 'Door Material',
        mainEntProt: 'Protection',
        mainEntLock: 'Lock Type',
        othEntDrMat: 'Door Material',
        othEntProt: 'Protection',
        othEntLock: 'Lock Type',
        windMat: 'Door Material',
        windProt: 'Protection',
        windLock: 'Lock Type',
        entRemarks: 'Entrance and Opening Comments'
      },
      entForm: {
        survNo: undefined,
        verCnt: undefined,
        mainEntDrMat: undefined,
        mainEntProt: undefined,
        mainEntLock: undefined,
        othEntDrMat: undefined,
        othEntProt: undefined,
        othEntLock: undefined,
        windMat: undefined,
        windProt: undefined,
        windLock: undefined,
        entRemarks: undefined,
        survDetType: 'entrance'
      },
      actionLabel: {
        exit: 'Exit',
        save: 'Save',
        reset: 'Reset'
      },
      loading: false,
      showErrorDialog: false,
      submitting: false,
      materialList: [],
      entProtectionList: [],
      entLockTypeList: []
    }
  },
  watch: {
    displayErrorDialog: {
      handler: function (messages) {
        if (messages && messages.length > 0) {
          this.showErrorDialog = true
        }
      },
      deep: true
    }
  },
  computed: {
    displayErrorDialog() {
      return this.messages
    },
    riskSurveyMenu() {
      return this.$store.state.underwriting.specialFuncUWSettings.riskSurveySettings.menu
    },
    riskSurveyMaster() {
      return this.$store.state.underwriting.specialFuncUWSettings.riskSurveyMaster
    },
    riskSurveyDetails() {
      return this.$store.state.underwriting.specialFuncUWSettings.riskSurveyDetails
    },
    riskSurveyMode() {
      return this.$store.state.underwriting.specialFuncUWSettings.riskSurveyMode
    },
    filterMainEntDrMatList() {
      return this.materialList.filter((list) => {
        return list.value === parseInt(this.entForm.mainEntDrMat)
      })
    },
    filterMainEntProtList() {
      return this.materialList.filter((list) => {
        return list.value === parseInt(this.entForm.mainEntProt)
      })
    },
    filterMainEntLockList() {
      return this.materialList.filter((list) => {
        return list.value === parseInt(this.entForm.mainEntLock)
      })
    },
    filterOthEntDrList() {
      return this.materialList.filter((list) => {
        return list.value === parseInt(this.entForm.othEntDrMat)
      })
    },
    filterOthEntProtList() {
      return this.materialList.filter((list) => {
        return list.value === parseInt(this.entForm.othEntProt)
      })
    },
    filterOthEntLockList() {
      return this.materialList.filter((list) => {
        return list.value === parseInt(this.entForm.othEntLock)
      })
    },
    filterWindMatList() {
      return this.materialList.filter((list) => {
        return list.value === parseInt(this.entForm.windMat)
      })
    },
    filterWindProtList() {
      return this.materialList.filter((list) => {
        return list.value === parseInt(this.entForm.windProt)
      })
    },
    filterWindLockList() {
      return this.materialList.filter((list) => {
        return list.value === parseInt(this.entForm.windLock)
      })
    }
  },
  methods: {
    async doInit() {
      this.entForm.survNo = this.riskSurveyMaster.survNo
      this.entForm.verCnt = this.riskSurveyMaster.verCnt
      this.loadInit()
    },
    loadInit() {
      this.entForm.mainEntDrMat = parseInt(this.riskSurveyDetails.mainEntDrMat)
      this.entForm.mainEntProt = parseInt(this.riskSurveyDetails.mainEntProt)
      this.entForm.mainEntLock = parseInt(this.riskSurveyDetails.mainEntLock)
      this.entForm.othEntDrMat = parseInt(this.riskSurveyDetails.othEntDrMat)
      this.entForm.othEntProt = parseInt(this.riskSurveyDetails.othEntProt)
      this.entForm.othEntLock = parseInt(this.riskSurveyDetails.othEntLock)
      this.entForm.windMat = parseInt(this.riskSurveyDetails.windMat)
      this.entForm.windProt = parseInt(this.riskSurveyDetails.windProt)
      this.entForm.windLock = parseInt(this.riskSurveyDetails.windLock)
      this.entForm.entRemarks = this.riskSurveyDetails.entRemarks
    },
    formatDate(date) {
      return formatDisplayDate(date)
    },
    doReset() {
      this.entForm.mainEntDrMat = undefined
      this.entForm.mainEntProt = undefined
      this.entForm.mainEntLock = undefined
      this.entForm.othEntDrMat = undefined
      this.entForm.othEntProt = undefined
      this.entForm.othEntLock = undefined
      this.entForm.windMat = undefined
      this.entForm.windProt = undefined
      this.entForm.windLock = undefined
      this.entForm.entRemarks = undefined
    }
  },
  created() {
    this.materialList = materialList
    this.entProtectionList = entProtectionList
    this.entLockTypeList = entLockTypeList
  },
  mounted() {
    this.doInit()
  },
  beforeMount() {
    if (this.$store.state.underwriting.specialFuncUWSettings.init !== 1) {
      this.$store.dispatch('specialFuncUWInit').then(() => {
        this.$store.dispatch('riskSurveyInit').then(() => {
          this.doInit()
        })
      })
    } else {
      this.$store.dispatch('riskSurveyInit').then(() => {
        this.doInit()
      })
    }
  },
  mixins: [MessageMixin],
  components: {}
}
</script>
<style lang="scss">
@import '../../../../../assets/scss/accounting.scss';
</style>
